import $ from 'jquery'

class MiniAbout {
  constructor($dataView, dataSelector) {
    this.$dataView = $dataView;
    this.dataSelector = dataSelector;
    this.data = {};
    this.init();
  }
  init() {
    const { $dataView } = this;
    const dataView = $dataView[0];
    if (dataView._miniAboutInit) return;
    dataView._miniAboutInit = true;
    this._setData();
    this._insertDOM();
  }
  _setData() {
    const {
      $dataView,
      dataSelector: { img, title, desc, actions },
      data,
    } = this;
    if (img) data.imgSrc = $dataView.find(img)[0]?.src;
    if (title) data.title = $dataView.find(title)?.text();
    if (desc) data.desc = $dataView.find(desc)?.text();
    if (actions && Array.isArray(actions)) {
      this.data.actions = [];
      actions.forEach(a => {
        let $target = $dataView.find(a);
        if ($target.length === 1) {
          let $btn = $target.clone();
          // let $btn = $(`<button data-click-to=${a}>${$target.html()}</button>`);
          $btn.removeAttr('id').addClass('btn--xs-only-icon').attr('data-click-to', a);
          this.data.actions.push($btn);
        }
      });
    }
  }
  _insertDOM() {
    const { imgSrc, title, desc, actions } = this.data;
    const template = `
      <section class="mini-about">
        <div class="container">
          <div class="mini-about__info">
            <div class="mini-about__img"><img src=${imgSrc} /></div>
            <div class="d-flex flex-column justify-content-center typography--body2">
              <div class="mini-about__title h5 m-0">${title}</div>
              <div class="mini-about__desc">${desc}</div>
            </div>
          </div>
          <div class="mini-about__actions"></div>
        </div>
      </section>
    `;
    const content = (this.content = {});
    const $el = (this.$el = $(template));

    if (!imgSrc) $el.find('.mini-about__img').remove();
    else content.$img = $el.find('.mini-about__img');

    if (!title) $el.find('.mini-about__title').remove();
    else content.$title = $el.find('.mini-about__title');

    if (!desc) $el.find('.mini-about__desc').remove();
    else content.$desc = $el.find('.mini-about__desc');

    if (!actions) $el.find('.mini-about__actions').remove();
    else {
      content.$actions = $el.find('.mini-about__actions');
      actions.forEach($btn => {
        content.$actions.append($btn);
      });
    }

    app.el.$header.after($el);
  }
  show() {
    this.$el.addClass('mini-about--show');
  }
  hide() {
    this.$el.removeClass('mini-about--show');
  }
}

$('[data-mini-about]').each(function () {
  const $this = $(this);
  const dataSelector = $this.data('mini-about');
  if (typeof dataSelector !== 'object') return;
  const miniAbout = new MiniAbout($this, dataSelector);
  const observer = new IntersectionObserver(changes => {
    for (const change of changes) {
      const { isIntersecting, intersectionRect } = change;
      if (!isIntersecting && intersectionRect.bottom < 1) miniAbout.show();
      else miniAbout.hide();
    }
  });
  observer.observe(this);
});
